<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">16 PF</h3>
    </div>

</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                
                <div *ngIf="texts&&isSim" #instructions class="m-b-30"></div>
                <div class="col-12">
                    <button class="btn waves-effect  btn-rounded btn-info mx-2" (click)="reload()">Cancelar</button>

                    <button *ngIf="isSim&&!instructionsReaded" type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="nextInstructions()" > Siguiente </button>
                    <button *ngIf="isSim&&instructionsReaded" type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" [disabled]="!simQuestions" (click)="startSim()" data-toggle="modal" data-target="#myModal" > Realizar simulación </button>
                    <button *ngIf="!isSim" type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" [disabled]="!questions" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>
                  
                </div>
                <div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title" id="myModalLabel">PF 16</h4>

                            </div>
                            <div *ngIf="selectedQuestion" class="modal-body">
                                <h4>Seleccione una opción</h4>

                                <p>{{selectedQuestion.title}}</p>
                                <div class="col">
                                    <a href="javascript:void(0)" class="btn btn-block btn-lg btn-info" style="font-size: 15px;" (click)="select('A')" >{{selectedQuestion.opcA.text}}</a>
                                    <br>
                                </div>
                                <div class="col">
                                    <a href="javascript:void(0)" class="btn btn-block btn-lg btn-info" style="font-size: 15px;" (click)="select('B')" >{{selectedQuestion.opcB.text}}</a>
                                    <br>
                                </div>
                                <div class="col">
                                    <a href="javascript:void(0)" class="btn btn-block btn-lg btn-info" style="font-size: 15px;" (click)="select('C')" >{{selectedQuestion.opcC.text}}</a>
                                    <br>
                                </div>


                            </div>

                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>

                <div id="formModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3 class="modal-title" id="myModalLabel">Por favor, complete el siguiente formulario</h3>
                            </div>
                            <div class="modal-body p-5">
                                <div class="row justify-content center">
                                    <div *ngFor="let field of testData.formModel; index as i" class="col-md-6 mt-2">
                                        <div *ngIf="field.type=='text'||field.type=='number'" class="form-group">
                                            <span><b>{{field.text}}</b></span>
                                            <input autocomplete="off" [(ngModel)]="formModel[i]" [type]="field.type"  class="form-control" [placeholder]="" >
                                        </div>
                                        <div *ngIf="field.type=='radio'" class="demo-radio-button">
                                            <span><b>{{field.text}}</b></span>
                                            <div class="row">
                                                <div class='col-md-6' *ngFor="let opt of field.data; index as j">
                                                    <input id="enum_answer_{{j}}" [value]='opt' type="radio" name="enums_{{i}}" [(ngModel)]="formModel[i]" >
                                                    <label for="enum_answer_{{j}}">
                                                        {{opt}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-success waves-effect pull-right" (click)="sendForm()">Continuar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>